var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-va",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320 0h320v480H320z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M282.4-735.1c0 .6 56 222.8 118.2 300.5 69.4 87.3 113.2 87.4 113.2 87.4l70.9-17.8s-41.6 2.1-123.9-104.2c-83.4-107.7-109.4-286-108.1-282.8l-70.3 16.9z",
    transform: "matrix(-.24 0 0 .1991 534 334.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M285-727.6c-1.5-9.4 33.9 221 140.2 327.2 53.1 53.1 88.6 53.1 88.6 53.1l88.6-17.7s-51.7 3.8-134-102.5c-83.5-107.8-108.6-263.3-108-263.9l-75.4 3.8z",
    transform: "matrix(.24 0 0 .1991 381.9 336.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M282.4-735.1c0 .6 56 222.8 118.2 300.5 69.4 87.3 113.2 87.4 113.2 87.4l70.9-17.8s-41.6 2.1-123.9-104.2c-83.4-107.7-109.4-286-108.1-282.8l-70.3 16.9z",
    transform: "matrix(.24 0 0 .1991 381.9 336.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M285-727.6c-1.5-9.4 33.9 221 140.2 327.2 53.1 53.1 88.6 53.1 88.6 53.1l88.6-17.7s-51.7 3.8-134-102.5c-83.5-107.8-108.6-263.3-108-263.9l-75.4 3.8z",
    transform: "matrix(-.24 0 0 .1991 534 334.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(.23995 .00428 -.00516 .19905 380 342.3)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 12.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01763 .00275 .01016 -.01162 411 329.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0173 .00313 .01036 -.0116 409.4 331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01763 .00275 .01016 -.01162 407.3 332.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01789 -.0011 .00628 -.01341 429.5 312.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0177 -.00038 .0068 -.01331 428.4 313.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01791 -.00081 .0066 -.0133 426.8 315.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01769 .00056 .0078 -.01292 425.8 316.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01765 -.00269 .00455 -.0139 433.9 305.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0175 -.00223 .00475 -.01392 433 307.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01765 -.00269 .00455 -.0139 431.7 309.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01754 -.00195 .00507 -.01384 430.5 311.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01784 .00155 .009 -.01227 418 324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01754 .00195 .0092 -.01225 416.4 325.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01784 .00155 .009 -.01227 414.5 327.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0173 .00313 .01036 -.0116 413.1 328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01794 .00014 .00759 -.01293 424 318.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01769 .00056 .0078 -.01292 422.7 319.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01784 .00155 .009 -.01227 421.4 320.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01754 .00195 .0092 -.01225 419.9 322.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01668 -.00552 .00122 -.01437 443.6 284.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01707 -.00392 .00278 -.01429 443.6 284.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01715 -.00439 .00258 -.01424 442.7 287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01707 -.00392 .00278 -.01429 442 288.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01664 -.00505 .0014 -.01443 445.7 277.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01668 -.00552 .00122 -.01437 445 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01664 -.00505 .0014 -.01443 444.4 282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01752 -.00323 .00393 -.01402 438 298.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01738 -.00277 .00413 -.01406 437.1 300)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01752 -.00323 .00393 -.01402 436 302.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0175 -.00223 .00475 -.01392 435.2 303.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01715 -.00439 .00258 -.01424 441 291.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01738 -.00277 .00413 -.01406 441.3 292.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01752 -.00323 .00393 -.01402 440.1 294.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01738 -.00277 .00413 -.01406 439.2 296.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01541 -.00768 -.00154 -.01435 448.9 266.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01656 -.00577 .0009 -.01438 448.9 268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01653 -.0053 .0011 -.01445 448.4 269.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01546 -.0072 -.00136 -.01443 449.6 259.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01541 -.00768 -.00154 -.01435 449.4 262.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01546 -.0072 -.00136 -.01443 449.1 264.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01656 -.00577 .0009 -.01438 447.7 272.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01664 -.00505 .0014 -.01443 447 273.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01668 -.00552 .00122 -.01437 446.3 275.8)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 12.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01781 .00178 -.00923 -.01216 503.2 324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0175 .00217 -.00943 -.01214 504.7 325.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01781 .00178 -.00923 -.01216 506.6 327.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01776 -.00209 -.00521 -.01373 486 305.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01762 -.00135 -.00574 -.01366 487.1 307.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0178 -.0018 -.00554 -.01364 488.5 309.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0177 -.00041 -.00676 -.01332 489.5 310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0174 -.00365 -.00345 -.01411 482.2 299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01728 -.00319 -.00365 -.01415 483 300.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0174 -.00365 -.00345 -.01411 484.1 303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01735 -.0029 -.00398 -.01409 485.2 304.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01792 .00057 -.00802 -.01274 496.7 318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01766 .00098 -.00823 -.01273 498.1 319.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01792 .00057 -.00802 -.01274 499.9 321.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0175 .00217 -.00943 -.01214 501.2 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0179 -.00085 -.00656 -.01332 491 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0177 -.00041 -.00676 -.01332 492.3 313.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01792 .00057 -.00802 -.01274 493.5 314.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01766 .00098 -.00823 -.01273 495 316.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01621 -.00642 -.00009 -.0144 474.2 276.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01672 -.00485 -.00165 -.01441 474.1 277.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01677 -.00532 -.00146 -.01435 475 279.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01672 -.00485 -.00165 -.01441 475.5 281.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0162 -.00595 -.00027 -.01447 472.6 270.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01621 -.00642 -.00009 -.0144 473.2 272.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0162 -.00595 -.00027 -.01447 473.6 274.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01723 -.00419 -.00282 -.01421 478.6 291.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01713 -.00372 -.00302 -.01425 479.4 293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01723 -.00419 -.00282 -.01421 480.4 295.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01728 -.00319 -.00365 -.01415 481.1 296.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01677 -.00532 -.00146 -.01435 476.3 283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01713 -.00372 -.00302 -.01425 475.9 285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01723 -.00419 -.00282 -.01421 476.9 287.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01713 -.00372 -.00302 -.01425 477.6 289)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01478 -.0085 .00266 -.01423 470.4 259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01607 -.00667 .00022 -.0144 470.2 260.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01608 -.0062 .00004 -.01448 470.6 262.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01486 -.00804 .00249 -.01433 470 252.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01478 -.0085 .00266 -.01423 470.2 254.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01486 -.00804 .00249 -.01433 470.3 256.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01607 -.00667 .00022 -.0144 471 264.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0162 -.00595 -.00027 -.01447 471.6 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01621 -.00642 -.00009 -.0144 472.2 268.4)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(-.23995 .00428 .00516 .19905 536 340.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.14437 0 0 .12085 423.6 295.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "m324.6-255.4-50.2 50.1L449.8-29.9l50.1-50z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.3,
    cy: -1428,
    r: 35.4,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    transform: "scale(-1 1) rotate(45 -177.9 -1104.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m-402-957 37.5 37.7-25 25-37.6-37.6c-12.5-12.5 12.5-37.5 25-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m-346.6-926.5-50.1 50a25 25 0 0 1-25-25c10.8-25.8 25-38.4 50-50a26.9 26.9 0 0 1 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m-352-931.9 37.7 37.6-50.2 50.1-37.5-37.5c5-20 30-45.1 50-50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m-309-889-50.1 50.1a25.1 25.1 0 0 1-25-25c10.8-25.9 25-38.4 50-50.1a26.9 26.9 0 0 1 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M-314.4-894.3 28.4-551.5l-50 50.1-342.9-342.8c5-20 30.1-45 50.1-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m49-531-50.2 50.1a25.1 25.1 0 0 1-25-25c10.8-25.9 25-38.5 50-50.1A26.9 26.9 0 0 1 49-531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m49-531 225.4 225.5-50 50.1L-1.3-480.9c5-20 30.1-45 50.1-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m186.7-418.2-75.1 75.1a25.1 25.1 0 0 1-25-25s0-25 25-50.1 50-25 50-25c11.7 1.5 21.5 12.4 25.1 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m186.7-418.2 50.2 75.1-50.1 50.1-75.2-50c-2.8-2.5 0-25.1 25-50.2s49-24.4 50.1-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.6-506.7c0-35.4 0-86.6 17.7-130C372-593.3 372-542 372-506.7h-35.4z",
    transform: "rotate(135 434.8 18.7) scale(1 -.81782)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "rotate(-45 399.4 -194.2) scale(1 .81782)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "rotate(135 434.8 18.7) scale(1 -.81782)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m-314.4-894.3 37.6 37.6c25 25 112.8 137.8 112.8 137.8s117.3 92.3 142.3 117.3L16-564c-25-25-180-129.8-180-129.8S-71.7-551.5-34.1-514l-37.6-37.6c-25-25-117.3-142.3-117.3-142.3S-289.3-769-314.4-794.1l-50-50c25 25 175.3 125.2 175.3 125.2s-100.2-150.3-125.3-175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M299.5-230.3A907.4 907.4 0 0 0 412.2-92.5a83 83 0 0 0 50.1 25s0-25-25-50a899 899 0 0 0-137.8-112.8zm-62.6-112.8c87.6 87.7 187.9 137.8 250.5 200.5 50.1 50 15.4 88.4 1.4 100.6-14 12.1-52 50.3-101.6-.4C324.5-105 274.4-205.3 186.7-293c0-25 25.1-50 50.1-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M218.3 257.9h23v73h-23z",
    transform: "matrix(-1.2487 -1.4214 -1.3593 1.3175 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "silver",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "m301.2 396.9 17.7 17.7-17.7 17.7 8.8 8.8 17.7-17.7 35.5 35.5-17.7 17.7 8.8 8.8 17.7-17.7 17.8 17.7-53.2 53.2-35.4-35.4 17.7-17.8 8.9 8.9 8.8-8.9-35.4-35.4-8.9 8.9 8.9 8.8-17.7 17.7-17.7-17.7 8.8-8.8-8.8-8.9-35.5 35.4 8.9 8.9 8.8-8.9 17.8 17.8-17.8 17.7-8.8-8.9-8.9 8.9 35.5 35.4 8.8-8.9-8.8-8.8 17.7-17.7 35.4 35.4-53.1 53.1-17.8-17.7 17.8-17.7-9-8.8-17.6 17.7-35.5-35.5 17.8-17.7-8.9-8.8-17.7 17.7-17.7-17.7 124-124z",
    transform: "matrix(-2.2946 0 0 2.2438 360.6 -1733.7)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M318.9 786.6V822l88.6 88.6v-70.8L389.8 822h-35.5L319 786.6z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m230.4 698.8 70.4 70.4.8 35.2-71.2-71.3v-34.3z",
    transform: "matrix(-1.1473 0 0 1.1219 157.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 259 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1189.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m230.4 698.8 35.8 35.4v35.4l-35.8-36.5v-34.3z",
    transform: "matrix(-1.1473 0 0 1.1219 218.8 -1349)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 137 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m283.5 822 53.1-53.1v-35.4l-70.9 70.8 17.8 17.8z",
    transform: "matrix(-1.1473 0 0 1.1219 137 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 35.4 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M301.2 804.3 265.8 769v-35.4l35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m389.8 822-53.2-53v-35.4l70.9 70.8-17.7 17.8z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m230.4 698 70.9 71h35.4l17.7 17.6v70.9l-124-124.4v-35z",
    transform: "matrix(-1.1473 0 0 1.1219 -66.2 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.3 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.3 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 -86.6 -1527)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 15 -1626.4)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M265.8 768.9v-35.4l17.7 17.7-17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1348.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M301.2 804.3 265.8 769l17.7-17.7 17.7 17.7v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 137 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3-17.7-17.7 17.7-17.7v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 15 -1586.6)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M196.5 254.2h25.2v80.2h-25.2z",
    transform: "matrix(-1.2509 -1.4194 -1.3614 1.3153 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M242.1 24.8c-147 0-113.1 164.2-100.4 124 9.4-29.5 35.5-70.8 65-80.2C246.9 55.8 233.4 78 248 78c14.7 0 1.2-22.2 41.4-9.4 29.5 9.4 55.6 50.7 65 80.2 12.7 40.3 53-124-112.3-124z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M389.8 166.5a141.8 141.8 0 0 1-283.5 0v-17.7c0-29 35.4 124 141.7 124s141.8-124.7 141.8-124v17.7z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(1.8992 0 0 1.8865 224 -100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M389.8 148.8a141.8 141.8 0 1 1-283.6 0 141.8 141.8 0 0 1 283.6 0zm-53.2 0c0 14.7 22.8 3 9.4 43a81 81 0 0 1-56.6 55c-40.2 12.7-26.7-9.4-41.4-9.4-14.6 0-1.1 22.1-41.3 9.4a80.2 80.2 0 0 1-56.6-56.6c-12.8-40.2 9.3-26.7 9.3-41.4s-22-1.1-9.3-41.3a80.2 80.2 0 0 1 56.6-56.6c40.2-12.8 26.7 9.3 41.3 9.3 14.7 0 1.2-22 41.4-9.3a80.3 80.3 0 0 1 56.6 56.6c12.7 40.2-9.4 26.6-9.4 41.3z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M126.5 157.7c-20.2 0-1.9 67.6-9 51.7a126.5 126.5 0 0 1 0-103.4c7.1-16-11.2 51.7 9 51.7z",
    transform: "matrix(-1.6618 0 0 1.7607 1107.2 -99.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M372 140a88 88 0 0 1-9.7 44.8c-8 13.7 9.8-44.8-8-44.8 17.7 0 1.7-58.6 8-44.8a107.7 107.7 0 0 1 9.8 44.8z",
    transform: "matrix(-1.8992 0 0 2.0316 1166.1 -106.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M296.3 263a123.5 123.5 0 0 1-96.5 0c-14.9-6.2 48.2 9.8 48.2-7.9 0 17.7 63.1 1.7 48.3 8zM248 42.6c0-17.7-63-1.7-48.2-8a123 123 0 0 1 96.5 0c14.8 6.3-48.3-9.7-48.3 8z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1257.6 -120)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(-1.2929 -1.3819 1.3912 -1.2842 808.9 712)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M267.7 308.5c-9.2 1.9-20.2 1-30 1-9.7 0-19.3-2.7-28.5-4.6l8.8-10.3a149.3 149.3 0 0 0 60 0l-10.3 14z",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(-1.3912 1.2842 1.2929 1.3819 847.4 -345.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 789.1 314.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M267.6 281.5c-9.2 1.9-17.1 3-26.9 3s-23-.8-32.3-2.7l9.6 12.8a149.5 149.5 0 0 0 60 0l-10.4-13.1z",
    transform: "matrix(-1.3912 1.2842 1.2929 1.3819 850.6 -315.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m174 271.8-.9 14.8-3.2 4.5 1-15 3-4.3zm156.5-6.2 3.6 4.2 1 13.6-2.9-3-1.7-14.8z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1237.6 329.9)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m513.8-790.2 35.4-17.7 35.4 17.7s-73.3 35.5-73.3 159.5c0 88.6 125.2 106.3 125.2 212.6 0 45.6-34.1 88.6-69.6 88.6s-88.6-17.7-141.7-70.9c35.4 17.7 76 37.3 106.3 36 19.6-.3 55-17.7 55-53 0-71-122.8-107-122.8-213.3 0-124 50-159.4 50-159.4z",
    transform: "matrix(-.24 0 0 .1991 534 334.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m520.3-790.2 46.6-17.7 10 17.7s-70.6 35.5-70.6 159.5c0 88.6 125.9 106.3 125.9 212.6 0 45.6-26.7 87.4-65.3 88.6-73.4 2.3-90.4-24-141.7-70.9 43.1 32.3 105 46.8 129 34.2 29.4-15.4 35-36 35-53.8 0-70.9-120.9-104.4-120.9-210.7 0-124 52-159.4 52-159.4z",
    transform: "matrix(-.24 0 0 .1991 534 334.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M513.3-789.7c7-2.4 36-18.2 71.3 17.3 17.8 17.7 17.8 53.1 17.8 70.8l53.1-53.1s-29-86.9-107.6-53.6a334.8 334.8 0 0 0-34.5 18.6z",
    transform: "matrix(-.24 0 0 .1991 534 334.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M523.8-796c8.8-2.8 36.7-6.3 64.6 18.6 17.7 17.7 19 42.9 19 60.6l40.6-38c3.4-3.1-24.8-81.2-99.2-54a154 154 0 0 0-25 12.9z",
    transform: "matrix(-.24 0 0 .1991 534 334.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(-.19534 -.02065 -.06668 .17315 439.6 337.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(.17775 .02412 .0031 -.13262 320.6 95.2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.14437 0 0 .12085 423.6 295.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 478.1 -504.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 354.3,
    cy: -1428,
    r: 35.4,
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    transform: "translate(124 283.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M460.6-1126.8v53.2h35.5v-53.2c0-17.7-35.5-17.7-35.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-1066h70.8a25.1 25.1 0 0 0 0-35.5c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-1073.6v53.1h70.8v-53.1c-17.7-10.6-53.2-10.6-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-1013h70.8a25.1 25.1 0 0 0 0-35.4c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    d: "M443-117h70.8v248.1h-70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-1020.5v484.8h70.8v-484.8c-17.7-10.6-53.2-10.6-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-506.7h70.8a25.1 25.1 0 0 0 0-35.4c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-506.7v318.9h70.8v-318.9c-17.7-10.6-53.2-10.6-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M425.2-329.5h106.3a25 25 0 0 0 0-35.5s-17.7-17.7-53.2-17.7-53.1 17.7-53.1 17.7c-7.1 9.4-6.3 24 0 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m425.2-329.5 17.7 88.6h70.9l17.7-88.6c.3-3.8-17.7-17.7-53.2-17.7s-51.9 17.3-53.1 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.6-506.7c0-35.4 0-86.6 17.7-130C372-593.3 372-542 372-506.7h-35.4z",
    transform: "matrix(1 0 0 .81782 124 173.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "matrix(-1 0 0 .81782 832.7 173.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "matrix(1 0 0 .81782 124 173.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M478.3-117a908.6 908.6 0 0 1 17.8 177.2 83 83 0 0 1-17.8 53.2s-17.7-17.7-17.7-53.2c0-17.7 0-88.6 17.7-177.1zM443-241c0 124-35.4 230.4-35.4 319 0 70.8 51.6 73.4 70 72.1 18.6-1.3 72.4-1.2 71.7-72.2 0-88.5-35.4-194.8-35.4-318.9-17.7-17.7-53.2-17.7-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M443-1020.5v53.2c0 35.4 17.6 177.1 17.6 177.1S443-642 443-606.6v53.2c0-35.4 35.4-219 35.4-219s35.5 165.9 35.5 219v-53.2c0-35.4-17.7-183.6-17.7-183.6s17.7-124 17.7-159.4v-70.9c0 35.4-35.4 212.6-35.4 212.6S443-985.1 443-1020.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M218.3 257.9h23v73h-23z",
    transform: "matrix(1.2487 -1.4214 1.3593 1.3175 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M242.1 24.8c-147 0-113.1 164.2-100.4 124 9.4-29.5 35.5-70.8 65-80.2C246.9 55.8 233.4 78 248 78c14.7 0 1.2-22.2 41.4-9.4 29.5 9.4 55.6 50.7 65 80.2 12.7 40.3 53-124-112.3-124z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M389.8 166.5a141.8 141.8 0 0 1-283.5 0v-17.7c0-29 35.4 124 141.7 124s141.8-124.7 141.8-124v17.7z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -753.9 -120)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M196.5 254.2h25.2v80.2h-25.2z",
    transform: "matrix(1.2509 -1.4194 1.3614 1.3153 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(-1.8992 0 0 1.8865 279.7 -100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M389.8 148.8a141.8 141.8 0 1 1-283.6 0 141.8 141.8 0 0 1 283.6 0zm-53.2 0c0 14.7 22.8 3 9.4 43a81 81 0 0 1-56.6 55c-40.2 12.7-26.7-9.4-41.4-9.4-14.6 0-1.1 22.1-41.3 9.4a80.2 80.2 0 0 1-56.6-56.6c-12.8-40.2 9.3-26.7 9.3-41.4s-22-1.1-9.3-41.3a80.2 80.2 0 0 1 56.6-56.6c40.2-12.8 26.7 9.3 41.3 9.3 14.7 0 1.2-22 41.4-9.3a80.3 80.3 0 0 1 56.6 56.6c12.7 40.2-9.4 26.6-9.4 41.3z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M126.5 157.7c-20.2 0-1.9 67.6-9 51.7a126.5 126.5 0 0 1 0-103.4c7.1-16-11.2 51.7 9 51.7z",
    transform: "matrix(1.6618 0 0 1.7607 -603.6 -99.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M372 140a88 88 0 0 1-9.7 44.8c-8 13.7 9.8-44.8-8-44.8 17.7 0 1.7-58.6 8-44.8a107.7 107.7 0 0 1 9.8 44.8z",
    transform: "matrix(1.8992 0 0 2.0316 -662.5 -106.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M296.3 263a123.5 123.5 0 0 1-96.5 0c-14.9-6.2 48.2 9.8 48.2-7.9 0 17.7 63.1 1.7 48.3 8zM248 42.6c0-17.7-63-1.7-48.2-8a123 123 0 0 1 96.5 0c14.8 6.3-48.3-9.7-48.3 8z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(1.2929 -1.3819 -1.3912 -1.2842 -305.2 712)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -719.6 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M267.7 308.5c-9.2 1.9-20.2 1-30 1-9.7 0-19.3-2.7-28.5-4.6l8.8-10.3a149.3 149.3 0 0 0 60 0l-10.3 14z",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -719.6 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(1.3912 1.2842 -1.2929 1.3819 -343.8 -345.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -285.5 314.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M267.6 281.5c-9.2 1.9-17.1 3-26.9 3s-23-.8-32.3-2.7l9.6 12.8a149.5 149.5 0 0 0 60 0l-10.4-13.1z",
    transform: "matrix(1.3912 1.2842 -1.2929 1.3819 -347 -315.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m174 271.8-.9 14.8-3.2 4.5 1-15 3-4.3zm156.5-6.2 3.6 4.2 1 13.6-2.9-3-1.7-14.8z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "silver",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -733.9 329.9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "m301.2 396.9 17.7 17.7-17.7 17.7 8.8 8.8 17.7-17.7 35.5 35.5-17.7 17.7 8.8 8.8 17.7-17.7 17.8 17.7-53.2 53.2-35.4-35.4 17.7-17.8 8.9 8.9 8.8-8.9-35.4-35.4-8.9 8.9 8.9 8.8-17.7 17.7-17.7-17.7 8.8-8.8-8.8-8.9-35.5 35.4 8.9 8.9 8.8-8.9 17.8 17.8-17.8 17.7-8.8-8.9-8.9 8.9 35.5 35.4 8.8-8.9-8.8-8.8 17.7-17.7 35.4 35.4-53.1 53.1-17.8-17.7 17.8-17.7-9-8.8-17.6 17.7-35.5-35.5 17.8-17.7-8.9-8.8-17.7 17.7-17.7-17.7 124-124z",
    transform: "matrix(2.2946 0 0 2.2438 143.1 -1733.7)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M318.9 786.6V822l88.6 88.6v-70.8L389.8 822h-35.5L319 786.6z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m230.4 698.8 70.4 70.4.8 35.2-71.2-71.3v-34.3z",
    transform: "matrix(1.1473 0 0 1.1219 346.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 244.7 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1189.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m230.4 698.8 35.8 35.4v35.4l-35.8-36.5v-34.3z",
    transform: "matrix(1.1473 0 0 1.1219 284.9 -1349)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 366.7 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m283.5 822 53.1-53.1v-35.4l-70.9 70.8 17.8 17.8z",
    transform: "matrix(1.1473 0 0 1.1219 366.7 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(1.1473 0 0 1.1219 468.3 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M301.2 804.3 265.8 769v-35.4l35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m389.8 822-53.2-53v-35.4l70.9 70.8-17.7 17.8z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m230.4 698 70.9 71h35.4l17.7 17.6v70.9l-124-124.4v-35z",
    transform: "matrix(1.1473 0 0 1.1219 569.8 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 509 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(1.1473 0 0 1.1219 509 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 590.3 -1527)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 488.6 -1626.4)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M265.8 768.9v-35.4l17.7 17.7-17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1348.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "M301.2 804.3 265.8 769l17.7-17.7 17.7 17.7v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 366.7 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.1,
    d: "m301.2 804.3-17.7-17.7 17.7-17.7v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 488.6 -1586.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452 279.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452.1 277.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452.1 275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452.1 273.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452 287.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452 286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452 283.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452 281.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452.3 262.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452.3 260.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452.3 257.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452.3 256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452.2 270.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452.2 268.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452.2 266.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452.2 264.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.7 313.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.8 311.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.8 309.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.8 307.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.6 322.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.7 320.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.7 317.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.7 316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.9 296.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452 294.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 452 292.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 452 290.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.8 305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.8 303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.9 300.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.9 298.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.4 347.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.4 345.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.4 343.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.4 341.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.3 354.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.3 352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.4 350.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.5 330.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.6 328.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.6 326.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.6 324.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.4 339.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.5 337.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.5 335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.5 333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.1 369.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.2 367.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.2 365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.2 363.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451 376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.1 373.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.1 371.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.2 360.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01446 .00854 -.00318 .01423 451.3 358.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01435 .009 -.00335 .01413 451.3 356.5)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 279.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 277.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 275.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 273.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 288.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 286.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 283.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 262.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 260.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 258.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 256.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 266.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 264.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.1 313.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.1 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.1 309.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.1 307.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.1 322.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.1 320.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.1 318.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.1 316.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 296.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 294.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 292.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 290.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 305.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.1 303.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455 301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455 299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.2 348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.2 346.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.2 343.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.2 341.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 354.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.2 352.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 350.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.2 331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.2 329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.1 326.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.2 324.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.2 339.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.2 337.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.2 335.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.2 333.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.3 369.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 367.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.3 365.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 363.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 376.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.3 373.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.3 361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01457 .0084 -.003 .01426 455.3 359.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01447 .00887 -.00316 .01416 455.3 356.8)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 12.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01804 .0045 .00258 .01426 466.7 266.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.00502 .01448 -.01369 .00945 463 262.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01316 .01078 -.0063 .01351 464.4 265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.011 .01222 -.01787 -.00248 462.7 259.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0104 .0123 -.018 -.00234 465.1 259.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01155 .01189 -.01775 -.003 452.2 259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01097 .01198 -.01788 -.00286 454.6 259.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01155 .01189 -.01775 -.003 457.6 259.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0104 .0123 -.018 -.00234 459.7 259.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01155 .01189 -.01775 -.003 448.7 258.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01268 .01087 -.01732 -.00452 450.4 258.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01676 .00696 -.01454 -.00862 449.5 257)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 12.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01456 -.00876 -.0151 .00691 500.9 356.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01407 -.00899 -.01526 .0068 503 355.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01456 -.00876 -.0151 .00691 505.8 355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01407 -.00899 -.01526 .0068 508 354.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01737 .00284 -.00405 .01407 524 347.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01147 .01155 .00717 .0131 526 341.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0175 .0033 -.00385 .01404 525.1 345.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0136 -.00978 -.01575 .0058 490.8 358.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0131 -.00997 -.0159 .00568 493 357.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01493 -.00832 -.0148 .00736 496.4 357.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01254 -.01046 -.0162 .00507 497.3 356.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01456 -.00876 -.0151 .00691 510.6 353.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01407 -.00899 -.01526 .0068 512.8 353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01096 -.01188 -.01683 .003 458.7 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01041 -.01198 -.01695 .00287 461 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01096 -.01188 -.01683 .003 463.8 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01041 -.01198 -.01695 .00287 466.1 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01096 -.01188 -.01683 .003 448.5 360.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01041 -.01198 -.01695 .00287 450.8 360.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01096 -.01188 -.01683 .003 453.6 360.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01041 -.01198 -.01695 .00287 455.9 360.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01244 -.01081 -.01634 .00452 480 359.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01231 -.01064 -.0163 .00483 482.5 359.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01284 -.01048 -.01616 .00495 485.3 359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0131 -.00997 -.0159 .00568 488 358.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01096 -.01188 -.01683 .003 469 359.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0113 -.0114 -.0167 .00377 471.6 359.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0125 -.01076 -.01631 .0046 474.8 359.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01107 -.01156 -.01677 .00353 476.6 359.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00824 -.01334 -.0172 .00043 416.7 358.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00768 -.01335 -.01729 .00028 419 358.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00983 -.01256 -.01706 .0019 422.4 359.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00927 -.01262 -.01717 .00176 424.6 359.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00768 -.01335 -.01729 .00028 408.8 357.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00824 -.01334 -.0172 .00043 411.6 357.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00768 -.01335 -.01729 .00028 413.9 357.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00983 -.01256 -.01706 .0019 437.7 359.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00927 -.01262 -.01717 .00176 440 360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01096 -.01188 -.01683 .003 443.4 360.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01041 -.01198 -.01695 .00287 445.7 360.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00983 -.01256 -.01706 .0019 427.5 359.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00927 -.01262 -.01717 .00176 429.8 359.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00983 -.01256 -.01706 .0019 432.6 359.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00927 -.01262 -.01717 .00176 434.9 359.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01773 -.00226 .00503 -.01378 399.9 338.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0141 -.00895 -.00376 -.01413 397.1 342.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.00947 -.01275 -.00925 -.01215 397 346.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.00376 -.01448 -.01383 -.00869 397.7 350.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01766 .00094 .00819 -.01275 405.4 333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01793 .00053 .00798 -.01276 403.7 334.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01757 -.0018 .00523 -.0138 401.2 336.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.001 -.01499 -.0159 -.0055 399.7 353.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00438 -.01435 -.01702 -.00258 402.7 355.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00824 -.01334 -.0172 .00043 406.5 356.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0174 -.00361 -.01096 .0111 516.7 351.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0168 -.00469 -.0118 .01058 516.9 352.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01764 -.00272 -.01013 .01164 521.7 349.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01667 -.00498 -.01207 .01037 518.6 351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01634 -.0062 .01318 .00926 511.5 341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0159 -.0065 .01336 .00919 509.6 340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01686 -.00512 .01228 .01009 506.4 338.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0159 -.0065 .01336 .00919 518.5 344.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01634 -.0062 .01318 .00926 516 343.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0159 -.0065 .01336 .00919 514 342.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.08053 0 0 .0956 438.4 288)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M212.6-1995v53.2h-53.1v35.5h53.1v106.3H248v-106.3h53.2v-35.5H248v-53.1h-35.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.2,
    cy: -1813.5,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    rx: 62,
    ry: 57.3,
    transform: "matrix(.57143 0 0 .61816 93.6 -679)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M602.4-1119.4c0 68.5-10.5 145.7-29.3 205-120-26.4-268-39.7-339-39.7-87.6 0-246.2 13.3-345.3 26.5a630.8 630.8 0 0 1-30.5-191.8c0-273.8 105.2-390.2 367.5-496 233.3 105.8 376.6 222.2 376.6 496z",
    transform: "matrix(1.0576 0 0 1.3394 -5.8 363.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.1715 0 0 .74463 -32.8 -634.9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.3-825.6-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z",
    transform: "matrix(1.1725 0 0 .74463 -33 -766.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.13516 -.18643 .29356 .72091 -190 -703.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.1416 .16986 -.26746 .725 182.2 -778.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.92597 -.09509 .18717 .73508 28.8 -521.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.92699 .091 -.17909 .7359 124.8 -554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.1725 0 0 .74463 -33 -674.5)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.0735 0 0 .74463 -9.3 -386.9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.3-825.6-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z",
    transform: "matrix(1.1042 0 0 .74463 -12.9 -518.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.06903 -.18643 .27645 .72092 -160.7 -455.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.0751 .16986 -.25188 .725 189.8 -530.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.87203 -.09509 .17626 .73508 45.4 -273.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.873 .091 -.16866 .7359 135.8 -306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.1042 0 0 .74463 -12.9 -426.4)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.105 0 0 .74463 -16.1 -865.2)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.3-825.6-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z",
    transform: "matrix(1.0799 0 0 .70238 -6.2 -1031.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.0455 -.17585 .27037 .68 -150.8 -971.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.05143 .16022 -.24634 .68386 192.1 -1042.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.85284 -.0897 .17238 .69338 50.8 -800.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.85378 .08583 -.16494 .69414 139.3 -830.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.0799 0 0 .70238 -6.2 -944.2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.1,
    cy: -822.1,
    fill: "#b90000",
    rx: 375.9,
    ry: 120.5,
    transform: "matrix(.96627 0 0 .41385 13 -517.5)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m513.8-790.2 35.4-17.7 35.4 17.7s-73.3 35.5-73.3 159.5c0 88.6 125.2 106.3 125.2 212.6 0 45.6-34.1 88.6-69.6 88.6s-88.6-17.7-141.7-70.9c35.4 17.7 76 37.3 106.3 36 19.6-.3 55-17.7 55-53 0-71-122.8-107-122.8-213.3 0-124 50-159.4 50-159.4z",
    transform: "matrix(.24 0 0 .1991 381.9 336.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.02071 -.00148 .00948 .02238 454.4 384)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m520.3-790.2 46.6-17.7 10 17.7s-70.6 35.5-70.6 159.5c0 88.6 125.9 106.3 125.9 212.6 0 45.6-26.7 87.4-65.3 88.6-73.4 2.3-90.4-24-141.7-70.9 43.1 32.3 105 46.8 129 34.2 29.4-15.4 35-36 35-53.8 0-70.9-120.9-104.4-120.9-210.7 0-124 52-159.4 52-159.4z",
    transform: "matrix(.24 0 0 .1991 381.9 336.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M513.3-789.7c7-2.4 36-18.2 71.3 17.3 17.8 17.7 17.8 53.1 17.8 70.8l53.1-53.1s-29-86.9-107.6-53.6a334.8 334.8 0 0 0-34.5 18.6z",
    transform: "matrix(.24 0 0 .1991 381.9 336.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M523.8-796c8.8-2.8 36.7-6.3 64.6 18.6 17.7 17.7 19 42.9 19 60.6l40.6-38c3.4-3.1-24.8-81.2-99.2-54a154 154 0 0 0-25 12.9z",
    transform: "matrix(.24 0 0 .1991 381.9 336.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(.19534 -.02065 .06668 .17315 476.4 339)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(-.17775 .02412 -.0031 -.13262 595.4 97)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.02071 -.00148 .00948 .02238 457.9 383.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.03487 -.00148 .01595 .02238 452.7 386.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.03487 -.00148 .01595 .02238 456 386.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.04323 -.00148 .01978 .02238 451.4 389.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 18,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.04323 -.00148 .01978 .02238 455.4 389.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h320v480H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.cf6a492acafefcbefa109e46322d5e8d.svg";
export { ForwardRef as ReactComponent };